import { PublicClientApplication } from "@azure/msal-browser";

const baseUrl = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: "7783dd92-7dff-4d39-bd92-ee561f63d659",
    authority: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    redirectUri: baseUrl,
    postLogoutRedirectUri: baseUrl,
  },
  cache: {
    cacheLocation: "localStorage", 
    storeAuthStateInCookie: false, 
  },
};

export const loginRequest = {
  scopes: ["openid", "offline_access"]
};

export const msalInstance = new PublicClientApplication(msalConfig);